<template>
  <div class="v-modal__backdrop" id="vm-backdrop" @click="onClickBackdrop">
    <div :class="containerClasses" @click="onClickContainer" id="vm-container">
      <div class="v-modal__body">
        <h4>Add Tags</h4>

        <div class="center-blk">
          <div class="text">
            <span>
              Add a new tag or select an existing one
            </span>
            <img :src="arrowLong" alt="arrow" />
          </div>

          <div class="tags">
            <VForm :name="name" :fields="fields"></VForm>
          </div>
        </div>
      </div>
      <div class="v-modal__actions">
        <VButton
          label="Cancel"
          extraClass="flat-file-button"
          inverted
          @click="onClickBackdrop"
        />
        <a
          class="flatfile-label"
          href="https://flatfile.io/?utm_source=user_app&utm_medium=footer&utm_name=923fe2e0-7967-11e8-914e-619390d70355"
          target="_blank"
        >
          <span> Powered by </span>
          <svg viewBox="0 0 1469 380" xmlns="http://www.w3.org/2000/svg">
            <g fill="#000" fill-rule="evenodd">
              <path
                d="M188.5 248.14L353.1 175a16.66 16.66 0 0 1 13.53 30.45L188.5 284.6 10.84 205.65A17.45 17.45 0 0 1 .48 189.7V96.04c0-7.2 4.24-13.74 10.83-16.67L188.5.62 365 79.06a17.45 17.45 0 0 1 0 31.9L188.5 189.4l-92.45-41.08a16.66 16.66 0 0 1 13.53-30.45l78.92 35.07 130.34-57.93L188.5 37.08 33.8 105.84v73.55l154.7 68.75zM23.9 270.2l164.6 73.16 164.6-73.16a16.66 16.66 0 0 1 13.53 30.45L188.5 379.81 10.37 300.64a16.66 16.66 0 1 1 13.53-30.45z"
                fill-rule="nonzero"
              ></path>
              <path
                d="M540.8 138.27v3.47h40.9v36.05h-40.9v137.3h-37.45v-137.3H477v-36.05h26.35v-3.47c0-46.8 26.34-73.85 78.35-70.38v36.06c-26.35-2.43-40.9 7.63-40.9 34.32M611.35 315.09h37.44V62h-37.44zM819.77 228.41c0-32.24-23.57-55.47-54.77-55.47-31.2 0-54.78 23.23-54.78 55.47 0 32.24 23.58 55.47 54.78 55.47 31.2 0 54.77-23.23 54.77-55.47zm37.45-86.67v173.35h-37.45v-24.97c-13.17 18.38-33.62 29.47-60.67 29.47-47.15 0-86.32-39.87-86.32-91.18 0-51.66 39.17-91.18 86.32-91.18 27.05 0 47.5 11.1 60.67 29.12v-24.61h37.45zM954.62 177.8V261c0 22.2 14.56 21.84 42.99 20.46v33.63c-57.55 6.93-80.43-9.01-80.43-54.1v-83.2h-31.9v-36.05h31.9V104.3l37.44-11.09v48.54h42.99v36.05h-43zM1086.93 138.27v3.47h40.9v36.05h-40.9v137.3h-37.45v-137.3h-26.34v-36.05h26.34v-3.47c0-46.8 26.35-73.85 78.36-70.38v36.06c-26.35-2.43-40.91 7.63-40.91 34.32M1159.02 314.94h37.44V141.59h-37.44v173.35zm-5.2-223.28a23.97 23.97 0 0 1 23.92-23.92 23.97 23.97 0 0 1 23.92 23.92c0 12.83-10.75 23.92-23.92 23.92-13.18 0-23.92-11.09-23.92-23.92zM1228.48 315.09h37.45V62h-37.45zM1430.67 213.85c-5.2-29.81-27.04-42.64-49.58-42.64-28.08 0-47.15 16.64-52.35 42.64h101.93zm-46.11 71.42c20.8 0 36.4-9.36 44.73-21.5l30.85 18.03c-15.94 23.58-41.95 37.8-75.93 37.8-57.2 0-94.3-39.19-94.3-91.2 0-51.3 37.1-91.17 91.53-91.17 51.66 0 87.02 41.6 87.02 91.53 0 5.2-.7 10.75-1.38 15.6h-138c5.9 27.04 27.74 40.91 55.48 40.91z"
              ></path>
            </g>
          </svg>
        </a>
        <VButton
          label="Continue"
          extraClass="flat-file-button"
          :disabled="
            formValues && formValues.tags && formValues.tags.length === 0
          "
          @click="_onSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapGetters, mapActions } from "vuex";

// components
import VButton from "@/components/VButton";
import VForm from "@/components/VForm";

import withTags from "@/mixins/withTags";

import { convertTagsToSelectListFormat } from "@/utils/util";

import flatFileIcon from "@/assets/images/flatfile-icon.png";
import arrowLong from "@/assets/images/arrow-long.svg";

export default Vue.component("ContactsFlatFileTagsModal", {
  components: {
    VButton,
    VForm,
  },

  mixins: [withTags],

  data() {
    return {
      flatFileIcon,
      arrowLong,
      name: "flatfile-tags",
    };
  },

  computed: {
    fields() {
      return [
        {
          name: "tags",
          label: "Tags",
          classType: "primary",
          multiple: true,
          elementType: "tags",
          selectItems: this._getTags,
          onAddHandler: this.handleAddTag,
          onSearchAsyncHandler: (input) =>
            this.fetchFormTagsList({ search: input }),
          isLoading: this._isTagsLoading,
        },
      ];
    },

    _isTagsLoading() {
      return this.isMainTagsLoading || this.isFormTagsLoading;
    },

    _getTags() {
      return convertTagsToSelectListFormat(this.tags("formTags"));
    },

    containerClasses() {
      return {
        "v-modal__container": true,
        [this.extraClass]: true,
      };
    },

    ...mapGetters("tags", {
      tags: "tags",
      isMainTagsLoading: "isLoading",
      isFormTagsLoading: "isFormTagsLoading",
    }),
  },

  methods: {
    _onSubmit() {
      this.$emit("submit", this.formValues.tags);
      setTimeout(() => this.clearForm(), 2000);
    },

    onClickContainer(evt) {
      evt.stopPropagation();
    },

    onClickBackdrop(evt) {
      evt.stopPropagation();
      this.$emit("close");
      this.clearForm();
    },

    onClickAction(action) {
      if (typeof action.click === "string") {
        this.$emit(action.click, action.value);
      } else {
        action.click(action.value);
      }
    },

    ...mapActions("tags", ["fetchFormTagsList"]),
  },

  async created() {
    await this.fetchFormTagsList();
  },
});
</script>

<style lang="scss">
#flatfile-tags {
  .v-input__label-wrapper {
    label {
      color: #1f1f1f;
      font-size: 15px;
      margin-bottom: 3px;
      font-family: "Lato-Bold", sans-serif;
    }
  }

  .select-ul__outer {
    border: 1px solid #c5c5c5;
    border-radius: 3px;
    padding: 13px 17px;
  }
}
</style>

<style lang="scss" scoped>
$ns: "v-";

.#{$ns}modal {
  &__backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;

    background: rgba(31, 31, 31, 0.9);
    padding: 30px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    background-color: $white;
    border: 1px solid $button-dark-color;
    border-radius: 5px;
    padding: 40px;
    width: 100%;
    height: 100%;
  }

  &__body {
    position: relative;
    flex-grow: 10;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: space-between;
    width: 100%;

    h4 {
      font-size: 24px;
      color: #50535b;
      font-family: "Lato-Bold", sans-serif;
    }

    .center-blk {
      display: flex;
      justify-content: space-between;
      width: 100%;
      top: 45%;
      position: absolute;
      transform: translateY(-45%);
    }

    .text {
      display: flex;
      align-items: center;

      span {
        margin-right: 30px;
        font-size: 24px;
        line-height: 1.2em;
        font-family: "Lato-Light", sans-serif;
      }
    }

    .tags {
      flex: 1;
      max-width: 550px;
      margin-left: 30px;
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .#{$ns}modal__container,
.modal-leave-active .#{$ns}modal__container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.v-modal__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  img {
    width: 117px;
    height: 21px;
  }

  .flatfile-label {
    color: #c6d1dd;
    text-align: center;
    font-size: 12px;
    display: block;
    position: absolute;
    left: 50%;
    bottom: 50%;
    margin-bottom: -7px;
    margin-left: -100px;
    width: 200px;
    cursor: pointer;
    text-decoration: none;

    span {
      line-height: 15px;
      vertical-align: top;
      font-weight: 400;
      font-size: 11px;
    }

    svg {
      height: 13px;
      position: relative;
      margin: 0 4px;
      vertical-align: top;
      display: inline-block;
      g {
        fill: #c6d1dd;
      }
    }

    &:hover {
      color: #4a90e2;
      text-decoration: none;

      svg {
        g {
          fill: #4a90e2;
        }
      }
    }
  }
}

.flat-file-button {
  font-family: "Lato-Regular", sans-serif;
  font-size: 15px;
  width: 188px;
  height: 44px;

  &.primary.inverted {
    border: 1px solid #c3c3c3;
    color: #9b9b9b;

    &:hover {
      background: transparent;
      border-color: #909090;
      color: #909090;
    }
  }

  &.primary {
    &:hover {
      background-color: #0d0dd9;
    }
  }
}
</style>
